import type { BrandedFare, BrandedFareFeature as BrandedFareFeatureType } from '@eti/schema-types';
import Feature from '../Feature';
import { INCLUDED } from '../constants';

export interface BrandedFareFeatureProps {
  shouldShowNotIncludedProducts: boolean;
  brandedFareData: BrandedFare;
  feature: BrandedFareFeatureType;
}

const BrandedFareFeature = ({
  shouldShowNotIncludedProducts,
  brandedFareData,
  feature,
}: BrandedFareFeatureProps) => {
  const isFeatureIncluded = feature.availability === INCLUDED;
  if (isFeatureIncluded || shouldShowNotIncludedProducts) {
    return (
      <Feature
        isIncluded={isFeatureIncluded}
        key={`${brandedFareData.selectionKey}${feature.name}${feature.code}`}
        label={feature.name}
      />
    );
  }
  return null;
};
export default BrandedFareFeature;
